import axios from 'axios'

export const fileAxios = axios.create()
